export default "__VITE_ASSET__cf3ee3b3__"